import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { Paper, LinearProgress, CircularProgress } from '@mui/material';
import k from '@gral/constants';
import { Typography } from '@ts/storybook';

export class HighlightedMessage extends React.Component {
  static displayName = 'HighlightedMessage';

  render() {
    return <div style={this._style()}>{this.props.children}</div>;
  }

  _style = () => ({
    fontSize: 18,
    fontWeight: 'bold',
  });
}

export class FlexRow extends React.Component {
  static displayName = 'FlexRow';

  static propTypes = {
    wrap: PropTypes.bool,
    style: PropTypes.object,
  };

  static defaultProps = {
    wrap: true,
    style: {},
  };

  render() {
    return <div style={this._style()}>{this.props.children}</div>;
  }

  _style = () => _.extend(k.gui.styles.flexContainer('row', this.props.wrap), this.props.style);
}

export class FlexRowSpacer extends React.Component {
  static displayName = 'FlexRowFlexSpacer';

  static propTypes = {
    width: PropTypes.any,
  };

  static defaultProps = { width: 15 };

  render() {
    return <div style={this._style()} />;
  }

  _style = () => ({
    flex: `0 0 ${this.props.width}px`,
    WebkitFlex: `0 0 ${this.props.width}px`,
  });
}

export class FlexRowFlexSpacer extends React.Component {
  static displayName = 'FlexRowFlexSpacer';

  render() {
    return <div style={this._style()} />;
  }

  _style = () => ({
    flex: '1 0 0px',
    WebkitFlex: '1 0 0px',
  });
}

export class FlexRowFlexItem extends React.Component {
  static displayName = 'FlexRowFlexItem';

  static propTypes = {
    minWidth: PropTypes.number,
  };

  static defaultProps = { minWidth: 0 };

  render() {
    return <div style={this._style()}>{this.props.children}</div>;
  }

  _style = () => {
    const out = {
      flex: `1 0 ${this.props.minWidth}px`,
      WebkitFlex: `1 0 ${this.props.minWidth}px`,
    };
    return _.extend(out, this.props.style);
  };
}

export class FlexRowItem extends React.Component {
  static displayName = 'FlexRowItem';

  render() {
    return <div style={this._style()}>{this.props.children}</div>;
  }

  _style = () => {
    const out = {
      flexShrink: 0,
      WebkitFlexShrink: 0,
    };
    return _.extend(out, this.props.style);
  };
}

export class PaperWithPadding extends React.Component {
  static displayName = 'PaperWithPadding';

  static propTypes = {
    style: PropTypes.object,
  };

  static defaultProps = { style: {} };

  render() {
    return <Paper style={this._style()}>{this.props.children}</Paper>;
  }

  _style = () => {
    const style = {
      margin: '10px 5px 10px 5px',
      padding: '10px 15px 15px 15px',
    };
    return _.extend(style, this.props.style);
  };
}

export const NewPaperWithPadding = props => {
  const { withoutScroll, className } = props;
  return (
    <div id='newPaperWithPadding'
      className={className}
      style={{
        display: 'flex',
        flexDirection: 'column',
        overflow: withoutScroll ? 'hidden' : 'auto',
        height: '-webkit-fill-available',
        width: '-webkit-fill-available',
        margin: '0px 5px 10px 5px',
        padding: '10px 15px 15px 15px',
        boxShadow: '0px 0px 10px 2px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
      }}
    >
      {props.children}
    </div>
  );
};

export class PaperSectionTitle extends React.Component {
  static displayName = 'PaperSectionTitle';

  static propTypes = {
    style: PropTypes.object,
  };

  static defaultProps = { style: {} };

  render() {
    return <Typography variant="h6" gutterBottom sx={this.props.sx} text={this.props.children} />;
  }

  _style = () => {
    const style = {
      fontSize: 14,
      fontWeight: 'bold',
      paddingTop: 3,
    };
    return _.extend(style, this.props.style);
  };
}

export class Loading extends React.Component {
  static displayName = 'Loading';

  static propTypes = {
    style: PropTypes.object,
    mode: PropTypes.string,
    type: PropTypes.string,
    withoutHeight: PropTypes.bool,
  };

  static defaultProps = {
    style: {},
    mode: 'indeterminate',
    type: 'linear',
  };

  render() {
    const height = this.props.withoutHeight ? {} : { height: 'calc(100% - 100px)' };

    if (this.props.type === 'linear') {
      return (
        <div style={{ ...height, width: '100%' }}>
          <LinearProgress style={this._style()} mode={this.props.mode} />
        </div>
      );
    }
    return <CircularProgress size={60} thickness={7} />;
  }

  _style = () => {
    const style = { fontSize: 14, width: '100%', marginTop: '10px' };

    return _.extend(style, this.props.style);
  };
}

const Misc = {
  HighlightedMessage,
  FlexRow,
  FlexRowSpacer,
  FlexRowFlexSpacer,
  FlexRowFlexItem,
  FlexRowItem,
  PaperWithPadding,
  NewPaperWithPadding,
  PaperSectionTitle,
  Loading,
};

export default Misc;
